import { CommonTypography } from './CommonTypography';
import './Typography.module.css';

/**
 * Typography component that has it's styles **scoped to the entire application**.
 *
 * **Warning!** May cause style leaks. Use with caution. Prefer `ScopedTypography` instead.
 */
export const Typography = CommonTypography;